import { Badge, Box, BadgeTypeMap, badgeClasses } from '@mui/material';
import React from 'react';
import { styled,Theme } from '@mui/material/styles';

interface IProps {
  color?: BadgeTypeMap['props']['color'];
  badgeContent: string | number;
  children?: React.ReactNode;
}

const RippleBadgeRoot = styled(Badge)(({ theme }: { theme: Theme }) => ({
  [`& .${badgeClasses.badge}::after`]: {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    opacity: 0.75,
    transform: 'scale(1)',
    display: 'block',
    zIndex: -1,
    animation: 'ripple 2s ease-in-out infinite',
  },
  '@keyframes ripple': {
    '0%': { opacity: 0, transform: 'scale(1.8)' },
    '75%': { opacity: 1, transform: 'scale(1)' },
    '100%': { opacity: 0, transform: 'scale(8)' },
  },
}));

const SignalBox = styled(Box)(({ theme }: { theme: Theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  opacity: 0.75,
  transform: 'scale(1)',
  animation: 'signal 0.7s ease forwards',
  zIndex: -1,
  '@keyframes signal': {
    to: { opacity: 0, transform: 'scale(1.5)' },
  },
}));

export const RippleBadge: React.FC<IProps> = ({
  color = 'primary',
  badgeContent,
  children,
}) => {
  return (
    <>
      <RippleBadgeRoot badgeContent={badgeContent} color={color}>
        {children}
      </RippleBadgeRoot>

      {badgeContent > 0 && <SignalBox />}
    </>
  );
};
